import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Prescriber } from "@modules/prescribers/types";
import { PrescriberFormValues } from "@modules/prescribers/validations";

import { createPrescriberService } from "./service";
import { UseCreatePrescriberMutationOptions } from "./types";

export function useCreatePrescriberMutation(
  options?: UseCreatePrescriberMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Prescriber, ApiError, PrescriberFormValues>({
    mutationFn: createPrescriberService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
